import { useLayoutEffect } from "react";

import { listenForProfileHistory } from "../hooks/profileHistoryGuard";

export function ProfileNavigationBoundary() {
  // Install before BrowserRouter so a cancelled traversal cannot unmount a dirty editor.
  useLayoutEffect(listenForProfileHistory, []);
  return null;
}
